import React from "react";
import { AppBar, Badge, Toolbar, IconButton, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import ChatIcon from '@mui/icons-material/Chat';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link, useLocation } from "react-router-dom";
import { useChatNotifications } from "./ChatNotifications";

const NavItem = ({ to, icon, label, isActive }) => (
  <IconButton
    component={Link}
    to={to}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: isActive ? "secondary.dark" : "text.secondary", // Highlight active link
      borderRadius: 2,
      p: 1,
      transition: 'color 0.2s',
    }}
  >
    {icon}
    <Typography variant="caption" sx={{ fontSize: 9, mt: 0.5, fontWeight: isActive ? 'bold' : 'normal' }}>
      {label}
    </Typography>
  </IconButton>
);

const BottomNav = () => {
    const location = useLocation();
    const { totalUnread } = useChatNotifications();
    const theme = useTheme();
    // En escritorio la navegación vive en SideNav
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const navItems = [
        { to: "/home", icon: <HomeIcon />, label: "Inicio" },
        {
            to: "/chats",
            icon: (
                <Badge badgeContent={totalUnread} color="secondary" max={99}>
                    <ChatIcon />
                </Badge>
            ),
            label: "Chats",
        },
        { to: "/profile", icon: <AccountCircleIcon />, label: "Perfil" },
    ];

    if (isDesktop) {
        return null;
    }

    return (
        <AppBar
            position="fixed"
            sx={{
                top: "auto",
                bottom: 0,
                bgcolor: "background.paper", // Use theme color
                borderTop: (theme) => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Toolbar sx={{ justifyContent: "space-around" }}>
                {navItems.map((item) => (
                    <NavItem 
                        key={item.to}
                        to={item.to}
                        icon={item.icon}
                        label={item.label}
                        isActive={location.pathname === item.to}
                    />
                ))}
            </Toolbar>
        </AppBar>
    );
};

export default BottomNav;
